<template>
  <el-dialog title="成果详情" :visible.sync="dialogVisible" width="1200px" top="5vh" class="achievement-detail-dialog"
    :close-on-click-modal="false" @close="handleDialogClose">
    <div class="achievement-detail">
      <!-- 左侧锚点导航 - 使用CommonLayout中的样式 -->
      <div class="anchor-nav pd20">
        <div v-for="(item, index) in anchorList" :key="item.id" class="anchor-item"
          :class="{ 'anchor-active': currentAnchor === item.id }" @click="scrollToAnchor(item.id)">
          <div class="anchor-line" v-if="index > 0"></div>
          <div class="anchor-content">
            <div class="anchor-text">{{ item.title }}</div>
            <div class="anchor-dot" :class="{ 'dot-active': currentAnchor === item.id }"></div>
          </div>
        </div>
      </div>

      <!-- 右侧表单内容（只读模式） -->

      <div class="form-content" ref="formContent">
        <div class="achievement-registration" id="section-unit">
          <div class="reTitle">科技成果转化双推双促工程</div>
          <div class="reTitle">《申报成果信息登记表》</div>
          <div>
            <el-form label-width="150px" :model="formLabelAlign" size="small" :rules="rules" ref="loginForm"
              class="loginFormByTab">
              <div class="formHeader">
                <div class="line"></div>
                <div class="formHeaderText">申报单位信息</div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="申报单位名称" prop="org_name">
                    <el-input v-model="formLabelAlign.org_name" placeholder="请输入申报单位名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="申报成立时间" prop="establish_date">

                    <el-date-picker v-model="formLabelAlign.establish_date" type="date" style="width: 100%;"
                      value-format="yyyy-MM-dd" placeholder="选择申报成立时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="申报所在省/市" prop="org_province_name">
                    <el-select filterable clearable v-model="formLabelAlign.org_province_name" placeholder="申报所在省/市"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.name" v-for="item in provinceList"
                        :key="item.id"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="单位产业属性" prop="industrial">
                    <el-select clearable filterable v-model="formLabelAlign.industrial" placeholder="请选择单位产业属性"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.industrialArray" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="单位业务属性" prop="business">
                    <el-select clearable filterable v-model="formLabelAlign.business" placeholder="请选择单位业务属性"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.businessArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="单位从业人数(人)" prop="org_person">
                    <el-input v-model="formLabelAlign.org_person" placeholder="请输入单位从业人数(人)"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="单位负责人姓名" prop="org_leader">
                    <el-input v-model="formLabelAlign.org_leader" placeholder="请输入单位负责人姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">

                </el-col>
              </el-row>

              <div class="formHeader" id="section-achievement">
                <div class="line"></div>
                <div class="formHeaderText">申报成果信息</div>
              </div>
              <el-form-item label="申报成果名称" prop="name" label-width="165px">
                <el-input v-model="formLabelAlign.name" placeholder="请输入申报成果名称"></el-input>
              </el-form-item>
              <el-form-item label="成果所属领域" prop="scope" label-width="165px">
                <el-select filterable clearable v-model="formLabelAlign.scope" placeholder="请选择成果所属领域" style="width: 100%;">
                  <el-option :label="item.title" :value="item.id" v-for="(item, index) in dictList"
                    :key="index"></el-option>

                </el-select>
              </el-form-item>
              <el-form-item label="成果简介" prop="profile" label-width="165px">
                <quill-editor ref="quillEditor" v-model="formLabelAlign.profile" :options="editorOption"></quill-editor>
                <!-- 隐藏的文件输入 -->
                <input type="file" ref="imageInput" accept="image/*" style="display: none;" @change="handleImageChange">
              </el-form-item>



              <div class="formHeader" id="section-innovation">
                <div class="line"></div>
                <div class="formHeaderText">技术创新亮点<span class="formHeaderTextSpan">（技术创新高度按项目所得最高荣誉选择）</span></div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="科技创新高度" prop="height">
                    <el-select filterable clearable v-model="formLabelAlign.height" placeholder="请选择科技创新高度" style="width: 100%;">
                      <el-option v-for="(item, key) in selectObj.heightArray" :key="key" :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="技术创新属性" prop="attribute">
                    <el-select filterable clearable v-model="formLabelAlign.attribute" placeholder="请选择技术创新属性"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.attributeArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="技术创新成果" prop="achievement">
                    <el-select filterable clearable v-model="formLabelAlign.achievement" placeholder="请选择技术创新成果"
                      style="width: 100%;">
                      <el-option v-for="(item, key) in selectObj.achievementArray" :key="key" :label="item.name"
                        :value="item.value">
                      </el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">

                </el-col>
              </el-row>

              <div class="formHeader" id="section-market">
                <div class="line"></div>
                <div class="formHeaderText">市场价值要点</div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="核心产品市场形态" prop="shape">
                    <el-select filterable clearable v-model="formLabelAlign.shape" placeholder="请选择核心产品市场形态" style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.shapeArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="项目已实现市场规模" prop="scale">
                    <el-select filterable clearable v-model="formLabelAlign.scale" placeholder="请选择项目已实现市场规模"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.scaleArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="项目未来市场预期" prop="expect">
                    <el-select filterable clearable v-model="formLabelAlign.expect" placeholder="请选择项目未来市场预期"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.expectArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">

                </el-col>
              </el-row>



              <div class="formHeader" id="section-transformation">
                <div class="line"></div>
                <div class="formHeaderText">转化要素难点</div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="转化所需资源难度" prop="difficulty">
                    <el-select filterable clearable v-model="formLabelAlign.difficulty" placeholder="请选择转化所需资源难度"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.difficultyArray" :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="转化资源到位程度" prop="degree">
                    <el-select filterable clearable v-model="formLabelAlign.degree" placeholder="请选择转化资源到位程度"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.degreeArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="转化项目投资力度" prop="strength">
                    <el-select filterable clearable v-model="formLabelAlign.strength" placeholder="请选择转化项目投资力度"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.strengthArray"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="转化项目已实现进程" prop="trl1_9">
                    <el-select filterable clearable v-model="formLabelAlign.trl1_9" placeholder="请选择转化项目已实现进程"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value" v-for="(item, index) in selectObj.trl1_9Array"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>



              <div class="formHeader" id="section-rd-leader">
                <div class="line"></div>
                <div class="formHeaderText">研发负责人</div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="姓名" prop="leader_name">
                    <el-input v-model="formLabelAlign.leader_name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="学历" prop="leader_education">
                    <el-select filterable clearable v-model="formLabelAlign.leader_education" placeholder="请选择学历"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.leader_educationArray" :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="职称" prop="leader_title">
                    <el-select filterable clearable v-model="formLabelAlign.leader_title" placeholder="请选择职称"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.leader_titleArray" :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">

                </el-col>
              </el-row>

              <div class="formHeader" id="section-rd-team">
                <div class="line"></div>
                <div class="formHeaderText">研发团队</div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="团队人数" prop="team_person">
                    <el-select filterable clearable v-model="formLabelAlign.team_person" placeholder="请选择团队人数"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.team_personArray" :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="中级以上人员占比" prop="team_intermediate">
                    <el-select filterable clearable v-model="formLabelAlign.team_intermediate" placeholder="请选择中级以上人员占比"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.team_intermediateArray" :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="团队合作经验" prop="team_experience">
                    <el-select filterable clearable v-model="formLabelAlign.team_experience" placeholder="请选择团队合作经验"
                      style="width: 100%;">
                      <el-option :label="item.name" :value="item.value"
                        v-for="(item, index) in selectObj.team_experienceArray" :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">

                </el-col>
              </el-row>

              <div class="formHeader" id="section-applicant">
                <div class="line"></div>
                <div class="formHeaderText">成果申报人信息</div>
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="11">
                  <el-form-item label="姓名" prop="user_name">
                    <el-input v-model="userInfo.name" disabled placeholder="请输入姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="电话" prop="legalPerson">
                    <el-input v-model="userInfo.mobile" disabled placeholder="请输入电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>


              <div class="formHeader" id="section-recommend">
                <div class="line"></div>
                <div class="formHeaderText">请选择您所提交项目的推荐单位/推荐个人（如无推荐单位/推荐个人，请选双推双促工程办公室）</div>
              </div>
              <el-row type="flex" justify="space-around">
                <div style="width: 40%;padding-left: 50px;">
                  <el-form-item prop="orgRec_id" label-width="0px">
                    <el-select filterable clearable v-model="formLabelAlign.orgRec_id" placeholder="请选择推荐单位" size="small"
                      style="width: 100%;">
                      <el-option :label="item.user_name" :value="item.id" v-for="(item, index) in unitList"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </div>
                <div class="formHeaderText" style="line-height: 30px;">或</div>
                <div style="width: 40%;padding-right: 50px;">
                  <el-form-item prop="personRec_id" label-width="0px">
                    <el-select filterable clearable v-model="formLabelAlign.personRec_id" placeholder="请选择推荐个人" size="small"
                      style="width: 100%;">
                      <el-option :label="item.user_name" :value="item.id" v-for="(item, index) in individualList"
                        :key="index"></el-option>

                    </el-select>
                  </el-form-item>
                </div>
              </el-row>
              <div class="formHeader mt30">
                <div class="line"></div>
                <div class="formHeaderText">成果申报附件目录</div>

              </div>
              <div class="uploadFont">
                <div>1、企业相关证明</div>
                <div>（1）企业营业执照复印件;</div>
                <div>（2）企业资质/上年度财务数据证明；</div>
                <div>（3）企业海归人才回国工作证明材料；</div>
                <div>（4）专利获奖证书等奖项证明复印件;</div>
                <div>（5）技术成果推广应用证明材料（包括合同、用户使用效果证明）；</div>
                <div>2、项目介绍</div>
                <div>（1）项目PPT、WORD等相关简介</div>
                <div>（2）项目重大工程技术获奖证明复印件;</div>
                <div>（3）技术成果鉴定（评价）证明复印件；</div>
                <div>（4）国家或省部级重大技术工程项目证明材料;</div>
                <div>3、企业负责人证明材料</div>
                <div>（1）身份证复印件；</div>
                <div>（2）最高学历、学位证书、专业技术职务证书复印件；</div>
                <div>（3）本人主要参与的技术成果所获专利证明的复印件；</div>
                <div>（4）本人获奖或主要参与的工程技术项目等各类获奖证明（包括获奖人员名单排序）复印件;</div>
                <div>（5）发表的重要论文、论著首页（封面）复印件；</div>
                <div>（6）本人主要参与的技术成果所取得的经济、社会效益的有关证明。</div>


              </div>

              <div class="formHeader" id="section-upload">
                <div class="line"></div>
                <div class="formHeaderText">附件上传<span
                    class="formHeaderTextSpan ml10">*单个附件或压缩包文件大小不能超过30MB,若多于9个，请提交成功基本信息后在项目预览的修改页面中补充附件。</span></div>
              </div>
              <div>
                <div class="pl30">
                  <!-- 图片预览区域 -->
                  <!-- <div v-if="imagePreviewList.length > 0" class="image-preview-list mb10">
                    <el-image
                      v-for="(img, index) in imagePreviewList"
                      :key="index"
                      style="width: 100px; height: 100px; margin-right: 10px; border-radius: 4px; cursor: pointer;"
                      :src="img.url"
                      :preview-src-list="imagePreviewList.map(i => i.url)"
                      fit="cover"
                    />
                  </div> -->
                  <el-upload class="upload-demo" ref="upload" :action="`${baseURL}/common/uploadFile`"
                    :on-success="handleSuccess" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList">
                    <el-button size="small" icon="el-icon-upload" type="primary">点击上传</el-button>
                    <!-- <el-button slot="trigger" icon="el-icon-upload" size="small" type="primary">点击上传</el-button> -->
                  </el-upload>
                </div>

              </div>
              <div class="confirmFont">
                本人对以上内容及全部附件材料进行了核查，对其客观性和真实性负责。
              </div>
              <el-row>
                <el-col :span="24" style="text-align: center; margin-top: 20px;">
                  <el-button type="primary" @click="onSubmit" :loading="loading" class="loginBtn">提交</el-button>
                </el-col>
              </el-row>
            </el-form>

          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'
import { mapState, mapGetters } from 'vuex'
import { getBaseUrl } from '@/config'
export default {
  name: 'AchievementDetailDialog',
  props: {
    achievementData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('userAbout', ['userInfo', 'isLogin']),
    // 图片预览列表（只显示图片类型的附件）
    imagePreviewList() {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp']
      return this.fileList.filter(file => {
        const ext = file.name ? file.name.split('.').pop().toLowerCase() : ''
        return imageExtensions.includes(ext) || (file.url && /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(file.url))
      })
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      fileList: [],
      dictList: [],
      unitList: [],
      individualList: [],
      selectObj: {},
      provinceList: [],
      loading: false,
      baseURL: getBaseUrl(),
      formLabelAlign: {
        // 申报单位信息
        org_name: '',                    // 申报单位名称
        establish_date: '',              // 申报成立时间
        org_province_name: '',           // 申报所在省/市
        industrial: '',                  // 单位产业属性
        business: '',                    // 单位业务属性
        org_person: '',                  // 单位从业人数
        org_leader: '',                  // 单位负责人姓名
        // 申报成果信息
        name: '',                        // 申报成果名称
        scope: '',                       // 成果所属领域
        profile: '',                     // 成果简介
        // 技术创新亮点
        height: '',                      // 科技创新高度
        attribute: '',                   // 技术创新属性
        achievement: '',                 // 技术创新成果
        // 市场价值要点
        shape: '',                       // 核心产品市场形态
        scale: '',                       // 项目已实现市场规模
        expect: '',                      // 项目未来市场预期
        // 转化要素难点
        difficulty: '',                  // 转化所需资源难度
        degree: '',                      // 转化资源到位程度
        strength: '',                    // 转化项目投资力度
        trl1_9: '',                      // 转化项目已实现进程
        // 研发负责人
        leader_name: '',                 // 姓名
        leader_education: '',            // 学历
        leader_title: '',               // 职称
        // 研发团队
        team_person: '',                 // 团队人数
        team_intermediate: '',           // 中级以上人员占比
        team_experience: '',             // 团队合作经验
        // 推荐单位/推荐个人
        orgRec_id: '',                   // 推荐单位
        personRec_id: '',                // 推荐个人
      },
      uploadFileList: [],
      editorOption: {
        placeholder: '请输入成果简介...',
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'color': [] }, { 'background': [] }],
              ['link', 'image']
            ],
            // 自定义图片上传处理器
            handlers: {
              image: function (image) {
                // 触发自定义的图片上传逻辑
                this.quill.root.parentNode.dispatchEvent(new CustomEvent('quill:image-click', {
                  bubbles: true,
                  detail: { image }
                }))
              }
            }
          }
        }
      },
      rules: {
        // 申报单位名称非空校验
        org_name: [
          { required: true, message: '请输入申报单位名称', trigger: 'blur' }
        ],
        // 单位所在省/市非空校验
        org_province_name: [
          { required: true, message: '请选择单位所在省/市', trigger: 'change' }
        ],
        // 申报成果名称非空校验
        name: [
          { required: true, message: '请输入申报成果名称', trigger: 'blur' }
        ],
        // 成果所属领域非空校验
        scope: [
          { required: true, message: '请选择成果所属领域', trigger: 'change' }
        ],
        // 成果简介非空校验
        profile: [
          { required: true, message: '请输入成果简介', trigger: 'blur' }
        ],
        // 推荐单位/推荐个人至少选一个校验
        orgRec_id: [
          {
            validator: (rule, value, callback) => {
              if (!value && !this.formLabelAlign.personRec_id) {
                callback(new Error('请选择推荐单位或推荐个人'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        personRec_id: [
          {
            validator: (rule, value, callback) => {
              if (!value && !this.formLabelAlign.orgRec_id) {
                callback(new Error('请选择推荐单位或推荐个人'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      dialogVisible: false,
      currentAnchor: 'section-unit',
      formData: {},
      anchorList: [
        { id: 'section-unit', title: '申报单位信息' },
        { id: 'section-achievement', title: '申报成果信息' },
        { id: 'section-innovation', title: '技术创新亮点' },
        { id: 'section-market', title: '市场价值要点' },
        { id: 'section-transformation', title: '转化要素难点' },
        { id: 'section-rd-leader', title: '研发负责人' },
        { id: 'section-rd-team', title: '研发团队' },
        { id: 'section-applicant', title: '成果申报人信息' },
        { id: 'section-recommend', title: '推荐单位/个人' },
        { id: 'section-upload', title: '附件上传' }
      ]
    }
  },
  watch: {
    achievementData: {
      handler(val) {
        if (val) {
          this.formData = { ...val }
          this.fileList = val.attachment || val.file_list || []
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handlePreview(e){
      console.log("handlePreview=========", e.url);
      window.open(e.url, '_blank')
    },
    onSubmit() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true

          // 处理表单数据
          const submitData = {
            ...this.formLabelAlign,
            // 处理附件上传列表
            attachment: this.uploadFileList
          }

          // 处理日期格式
          // if (submitData.establish_date) {
          //   submitData.establish_date = this.$moment(submitData.establish_date).format('YYYY-MM-DD HH:mm:ss')
          // }

          try {
            const res = await this.$API.addAchievement(submitData)
            console.log("res=========", res);
            this.$message.success('提交成功')
            // 成功后关闭弹框并通知父组件刷新列表
            this.dialogVisible = false
            this.$emit('success')

          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error(error)
          } finally {
            this.loading = false
          }
        } else {
          console.log('表单校验失败')
          return false
        }
      })
    },
    // 绑定图片点击事件监听器
    bindQuillImageClick() {
      const quillEditor = this.$refs.quillEditor
      if (!quillEditor) return

      const quillEditorEl = quillEditor.$el
      if (!quillEditorEl) return

      quillEditorEl.addEventListener('quill:image-click', (e) => {
        console.log('点击了图片按钮', e)
        // 触发文件选择
        this.$refs.imageInput.click()
      })
    },

    // 处理图片文件选择
    handleImageChange(event) {
      const file = event.target.files[0]
      if (file) {
        console.log('选择了图片:', file.name)
        this.uploadImage(file)
      }
      // 清空 input，允许重复选择同一文件
      event.target.value = ''
    },

    // 上传图片到服务器
    async uploadImage(file) {
      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件')
        return
      }

      // 检查文件大小 (例如限制 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 5MB')
        return
      }

      const formData = new FormData()
      formData.append('file', file)

      try {
        console.log('开始上传图片...')

        // 使用项目封装的 API 接口
        const res = await this.$API.uploadFile(formData)

        console.log('上传响应:', res)

        // 根据实际接口返回格式获取图片URL
        const imageUrl = this.getImageUrlFromResponse(res)

        if (imageUrl) {
          // 插入图片到编辑器
          this.insertImageToEditor(imageUrl)
          this.$message.success('图片上传成功')
        } else {
          throw new Error('未获取到图片地址')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        this.$message.error('图片上传失败，将使用本地预览')
        // 上传失败时使用 Base64
        this.insertBase64Image(file)
      }
    },

    // 从响应中获取图片URL
    getImageUrlFromResponse(res) {
      if (res) {
        return res.url
      }
      return null
    },

    // 插入图片到编辑器
    insertImageToEditor(imageUrl) {
      const quill = this.$refs.quillEditor.quill
      const range = quill.getSelection()
      const index = range ? range.index : 0
      quill.insertEmbed(index, 'image', imageUrl)
      quill.setSelection(index + 1)
    },

    // Base64 备选方案
    insertBase64Image(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.insertImageToEditor(e.target.result)
      }
      reader.readAsDataURL(file)
    },
    handleRemove(e) {
      console.log("e=========", e);
      this.uploadFileList = this.uploadFileList.filter(item => item.file_path !== e.url)
      this.fileList = this.fileList.filter(item => item.url !== e.url)
      console.log("this.uploadFileList=========", this.uploadFileList);
      console.log("this.fileList=========", this.fileList);
    },
    handleSuccess(e) {
      this.fileList.push({
        name: e.url_name,
        url: e.url,
      })
      this.uploadFileList.push({
        file_name: e.url_name,
        file_path: e.url,
        file_suffix: e.file_ext,
        size: e.file_size,
      })
      console.log("e=========", e);
    },
    open(id) {
      // 使用 Promise.all 等待所有接口完成
      Promise.all([
        this.getProvinceList(),
        this.getSelect(),
        this.getRecommendListData(),
        this.getDictList()
      ]).then(() => {
        if (id) {
          this.getDetail(id)
        }
      })

      this.currentAnchor = 'section-unit'
      this.dialogVisible = true

      // 延迟添加滚动监听，确保DOM已渲染
      this.$nextTick(() => {
        this.bindQuillImageClick()
        const formContent = this.$refs.formContent
        if (formContent) {
          formContent.addEventListener('scroll', this.handleScroll)
          // 初始化检查一次
          this.handleScroll()
        }
      })
    },
    getDictList() {
      return this.$API.getDict({ pid: 66 }).then(res => {
        this.dictList = res.data
      })
    },
    getRecommendListData() {
      return this.$API.getLoginRecommendList({ identify: 1 }).then(res => {
        this.unitList = res.data
      }).then(() => {
        return this.$API.getLoginRecommendList({ identify: 2 }).then(res => {
          this.individualList = res.data
        })
      })
    },
    getSelect() {
      return this.$API.getSelectList().then(res => {
        console.log("res=========", res);
        this.selectObj = res.data
      })
    },
    getProvinceList() {
      return this.$API.getProvinceList({ pid: 0 }).then(res => {
        console.log("res=========", res);
        this.provinceList = res.data
      })
    },
    handleScroll() {
      const formContent = this.$refs.formContent
      if (!formContent) return

      const scrollTop = formContent.scrollTop
      const scrollHeight = formContent.scrollHeight
      const clientHeight = formContent.clientHeight
      const anchorIds = this.anchorList.map(item => item.id)

      // 判断是否滚动到底部
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50

      if (isAtBottom) {
        // 滚动到底部时直接选中最后一个
        this.currentAnchor = anchorIds[anchorIds.length - 1]
        return
      }

      // 正序查找当前显示的section
      for (let i = 0; i < anchorIds.length; i++) {
        const element = formContent.querySelector(`#${anchorIds[i]}`)
        if (element) {
          const offsetTop = element.offsetTop
          const nextElement = formContent.querySelector(`#${anchorIds[i + 1]}`)
          const nextOffsetTop = nextElement ? nextElement.offsetTop : Infinity

          // 判断当前section是否在视口内
          if (scrollTop >= offsetTop - 100 && scrollTop < nextOffsetTop - 100) {
            this.currentAnchor = anchorIds[i]
            break
          }
        }
      }
    },
    getDetail(id) {
      this.$API.getAchievementDetail({ xid: id }).then(res => {
        this.formLabelAlign = res.data
        // 将所有下拉框字段转换为字符串类型
        const selectFields = [
          'industrial', 'business', 'attribute', 'achievement',
          'shape', 'scale', 'expect', 'difficulty', 'degree', 'strength',
          'trl1_9', 'leader_education', 'leader_title', 'team_person',
          'team_intermediate', 'team_experience','height'
        ]
        selectFields.forEach(field => {
          if (this.formLabelAlign[field] !== undefined && this.formLabelAlign[field] !== null) {
            this.formLabelAlign[field] = Number(this.formLabelAlign[field])
          }
        })
        this.fileList = res.data.attachment.map(item => {
          return {
            name: item.file_name,
            url: item.file_path,
          }
        })
        this.uploadFileList = res.data.attachment
        console.log("fileList========", this.fileList)
        console.log("fileList========", this.fileList)
        console.log("res=========", res);
      })
    },
    scrollToAnchor(anchorId) {
      this.currentAnchor = anchorId
      const formContent = this.$refs.formContent
      if (formContent) {
        const targetElement = formContent.querySelector(`#${anchorId}`)
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    },
    downloadFile(file) {
      if (file.file_path || file.url) {
        window.open(file.file_path || file.url, '_blank')
      } else {
        this.$message.warning('文件地址无效')
      }
    },
    handleDialogClose() {
      // 移除滚动监听
      const formContent = this.$refs.formContent
      if (formContent) {
        formContent.removeEventListener('scroll', this.handleScroll)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.mb10 {
  margin-bottom: 10px;
}

.achievement-detail-dialog {
  ::v-deep .el-dialog {
    width: 1200px !important;
    max-height: 90vh;
    overflow: hidden;
  }

  ::v-deep .el-dialog__body {
    max-height: calc(90vh - 60px);
    padding: 0;
  }
}

.achievement-detail {
  display: flex;
  height: calc(90vh - 110px);
}

.pd20 {
  padding: 20px;
}

.anchor-nav {
  width: 200px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #eee;
  padding: 20px 10px;
  overflow-y: auto;
}

.anchor-item {
  position: relative;
  cursor: pointer;
  padding: 10px 0;
}

.anchor-line {
  position: absolute;
  right: 14px;
  top: -15px;
  width: 1px;
  height: 30px;
  background: #ddd;
}

.anchor-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.anchor-text {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 13px;
  color: #666;
  flex: 1;
}

.anchor-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  flex-shrink: 0;
  margin-left: 10px;
  transition: all 0.3s;
}

.anchor-active .anchor-text {
  color: #2F86FF;
  font-weight: 500;
}

.anchor-active .anchor-dot,
.dot-active {
  background: #2F86FF;
  box-shadow: 0 0 0 3px rgba(47, 134, 255, 0.2);
}

.quill-editor .ql-container {
  font-size: 14px;
}

::v-deep .ql-container {
  height: 200px !important;
}

.form-content {
  flex: 1;
  min-width: 0;
  background: #fff;
  overflow-y: auto;
  padding: 20px;
}

.reTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 20px;
  color: #595959;
  line-height: 30px;
  text-align: center;
  margin-bottom: 20px;
}

.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e4e7ed;

  &:last-child {
    border-bottom: none;
  }
}

.formHeader {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .formHeaderText {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #231815;
  }

  .formHeaderTextSpan {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #ED4014;
    margin-left: 10px;
  }
}

.line {
  width: 3px;
  height: 19px;
  background: #2F86FF;
  margin-right: 10px;
}

.info-value {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #303133;
  word-break: break-all;

  &.rich-text {
    line-height: 1.8;

    ::v-deep img {
      max-width: 100%;
      height: auto;
    }
  }
}

.file-list {
  .file-item {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 10px;

    i {
      margin-right: 10px;
      color: #409EFF;
    }

    span {
      flex: 1;
      font-size: 14px;
      color: #303133;
    }
  }
}

.no-data {
  padding: 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.formHeaderTextSpan {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #ED4014;
}

.uploadFont {
  padding-left: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 30px;

}
</style>
